import React from "react";
import { FieldArray, useFormikContext } from "formik";
import Input from "./InputField";
import FormFieldArray from "./FormFieldArray";
import Collapsible from "react-collapsible";
import {IoCloseCircle} from 'react-icons/io5'

const FormSectionArray = () => {
  const { values } = useFormikContext();

  return (
    <FieldArray name="formSections">
      {({ insert, remove, push }) => (
        <div>
          <button
            type="button"
            className="border border-slate-600 text-sm px-2 py-1.5 mb-2 w-full mt-2" 
            onClick={() =>
              push({
                name: "",
                activeStatus:true,
                IsOfficial:false,
                formFields: [
                  {
                    label: "",
                    activeStatus: true,
                    isCalculated: false,
                    calculationFormula: "",
                    calculationFormulaeDependents:"",
                    formFieldTypeId: 0,
                    required: false,
                    formFieldOptions: [],
                    isImage:false,
                    imageSize:""
                  },
                ],
              })
            }
          >
            Add Section
          </button>
          
          {values.formSections.length > 0 &&
            values.formSections.map((formSection, index) => (
              <Collapsible
              key={index}
              trigger={<div className="w-full p-3 flex justify-between items-center">
                
                <span>{values.formSections[index].name.length===0?`Section ${index+1}`:values.formSections[index].name}</span>
                {values.formSections[index]?.formSectionId==null&&<IoCloseCircle onClick={() => remove(index)} className="text-red-600 text-3xl  cursor-pointer transition-all ease-in-out hover:scale-110"/>}
                </div>}
              triggerClassName="font-medium text-xl"
              className=" mb-4 border"
              openedClassName="border w-full mb-10"
              open={true}
              triggerOpenedClassName="text-xl font-medium w-full"
              contentInnerClassName="p-4 mt-3 border-t w-full"
            >
              <div className="flex w-full flex-col space-y-3" key={index}>
                <div className='flex justify-end'>
                  <Input
                  type="checkbox" 
                  name={`formSections[${index}].isOfficial`}
                  id={`formSections[${index}].isOfficial`}
                  label="Official's Only"
                />
                </div>
                <div className='flex justify-end  pr-12'>
                  <Input
                  type="checkbox" 
                  name={`formSections[${index}].activeStatus`}
                  id={`formSections[${index}].activeStatus`}
                  label="Active"
                />
                </div>
                 
              
                <div className="grid lg:grid-cols-3 gap-4">
                  <Input
                    name={`formSections.${index}.name`}
                    id={`formSections.${index}.name`}
                    placeholder="Section Name"
                    label="Section Name"
                  />
                 
                   </div>
                <FormFieldArray id={index} />
              
              </div>
              </Collapsible> 
            ))}
        </div>

      )}
      
    </FieldArray>
  );
};

export default FormSectionArray;